<template>
  <path
    d="M21.0001 3.41026C21.0001 2.52026 19.9201 2.07026 19.2901 2.70026L12.6901 9.30026L21.0001 17.6103V3.41026ZM21.4401 20.8803L5.62005 5.06026C5.23005 4.67026 4.60005 4.67026 4.21005 5.06026C3.82005 5.45026 3.82005 6.08026 4.21005 6.47026L9.87005 12.1303L2.71005 19.2903C2.08005 19.9203 2.52005 21.0003 3.41005 21.0003H18.7301L20.0201 22.2903C20.4101 22.6803 21.0401 22.6803 21.4301 22.2903C21.8301 21.9003 21.8301 21.2703 21.4401 20.8803Z"
  />
</template>
